"use strict";
var logo = document.querySelector(".logo");
var promise1 = new Promise(function(resolve) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
promise1.then(function() {
    var divEl = document.createElement("div");
    divEl.classList.add("message");
    divEl.textContent = "Promise was resolved!";
    document.body.append(divEl);
}).catch();
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise was rejected!"));
    }, 3000);
});
promise2.then().catch(function() {
    var divEl = document.createElement("div");
    divEl.classList.add("message", "error-message");
    divEl.textContent = "Promise was rejected!";
    document.body.append(divEl);
});

//# sourceMappingURL=index.d4a169a9.js.map
